import NotFound from './NotFound';
import React, { useEffect, useRef, useState } from "react";
import { Swiper, SwiperSlide } from "swiper/react";
import { useParams, useNavigate, useLocation, Link } from 'react-router-dom';

// Import Swiper styles
import "swiper/css";
import "swiper/css/free-mode";
import Omshasntiom from "../images/omshasntiom.png";
import Nushrat from "../images/nushrat.png";
import Pushpa from "../images/pushpa.png";
import Tridev from "../images/tridev.png";
import "swiper/css/navigation";
import "swiper/css/thumbs";
// import required modules
import { Autoplay, FreeMode, Navigation, Thumbs } from "swiper/modules";
import { apiUrl, assetsUrl } from "../config/config";
import axios from "axios";
import { useSelector, useDispatch } from "react-redux";
import Overlay from '../components/Overlay';
import InnerImageZoom from 'react-inner-image-zoom';
import 'react-inner-image-zoom/lib/InnerImageZoom/styles.min.css';
import { Button, Modal } from "react-bootstrap";
import Swal from 'sweetalert2';
import { getRoundedDiscountPercent, getRoundedSellingPrice, roundNumber } from "../utils/price";
import Helmet from "react-helmet";

const SITE_URL = "https://www.blisstainment.com";

const plainText = (value = "") => String(value)
  .replace(/<[^>]*>/g, " ")
  .replace(/&nbsp;/gi, " ")
  .replace(/&amp;/gi, "&")
  .replace(/\s+/g, " ")
  .trim();

const ProductDetails = () => {
  // const { state } = useLocation();
  const { slug } = useParams();
    const [missingSlug, setMissingSlug] = useState(null);
  // console.log('slug >>', slug);
  const swiperRef = useRef(null);
  const swiperRefmodal = useRef(null);
  const [showloding, setshowloding] = useState(false);
  const [productddetails, setproductddetails] = useState({});
  const [offerdata, setofferdata] = useState({});
  const [relatedproducts, setrelatedproducts] = useState([]);
  const [turntableContents, setturntableContents] = useState([]);
  const [selectedTurntableTab, setselectedTurntableTab] = useState(0);
  const [discountpercent, setdiscountpercent] = useState(0);
  const [showmodal, setshowmodal] = useState(false);

  const [shownotifymodal, setshownotifymodal] = useState(false);

  const [firstname, setfirstname] = useState("");
  const [lastname, setlastname] = useState("");
  const [email, setemail] = useState("");
  const [number, setnumber] = useState("");

  const [quantity, setquantity] = useState(1);
  // console.log('state >>', state);
  // const [thumbsSwiper, setThumbsSwiper] = useState();
  const cartdata = useSelector((store) => store.userReducer.cartdata);
  const isTurntableCategory = (product) => {
    const categoryValue = String(product?.category ?? product?.catname ?? product?.category_name ?? "").toLowerCase();
    const typeValue = String(product?.type ?? product?.product_type ?? "").toLowerCase();
    return (
      typeValue === "turntables" ||
      categoryValue === "4" ||
      categoryValue === "turntables" ||
      categoryValue === "turn-tables" ||
      categoryValue === "turn tables"
    );
  };
  const isTurntableProduct = isTurntableCategory(productddetails) || turntableContents?.length > 0;
  const visibleRelatedProducts = relatedproducts?.filter((item) => item?.slug !== productddetails?.slug);
  const isVideoFile = (file) => /\.(mp4|mov|m4v|webm|avi|mkv)$/i.test(String(file || "").split("?")[0]);
  const productMediaItems = [
    productddetails?.image1,
    productddetails?.image2,
    productddetails?.image3,
    productddetails?.image4,
    productddetails?.image5,
    productddetails?.image6,
    productddetails?.image7,
    productddetails?.image8,
  ].filter(Boolean).map((file) => ({
    file,
    url: assetsUrl + "products/" + file,
    type: isVideoFile(file) ? "video" : "image",
  }));
  const canonicalUrl = `${SITE_URL}/entertainment/${encodeURIComponent(slug || "")}`;
  const productName = plainText(productddetails?.name);
  const productDescription = plainText(productddetails?.description).slice(0, 300)
    || `Buy ${productName || "music and entertainment products"} online from Blisstainment with secure delivery across India.`;
  const sellingPrice = getRoundedSellingPrice(productddetails?.price, discountpercent);
  const primaryImage = productMediaItems.find((item) => item.type === "image")?.url;
  const categoryUrl = productddetails?.subcategory
    ? String(productddetails?.category) === "4"
      ? `${SITE_URL}/turntables/${encodeURIComponent(productddetails.subcategory)}`
      : `${SITE_URL}/sub-category/${encodeURIComponent(productddetails.subcategory)}/${String(productddetails?.category) === "2" ? "Movie" : "Music"}`
    : SITE_URL;
  const productSchema = productName ? {
    "@context": "https://schema.org",
    "@type": "Product",
    name: productName,
    description: productDescription,
    sku: productddetails?.seller_sku_id || String(productddetails?.id || slug),
    brand: productddetails?.brand ? { "@type": "Brand", name: productddetails.brand } : undefined,
    image: productMediaItems.filter((item) => item.type === "image").map((item) => item.url),
    offers: {
      "@type": "Offer",
      url: canonicalUrl,
      priceCurrency: "INR",
      price: sellingPrice,
      availability: Number(productddetails?.stock) > 0
        ? "https://schema.org/InStock"
        : "https://schema.org/OutOfStock",
      itemCondition: "https://schema.org/NewCondition",
    },
  } : null;
  const breadcrumbSchema = productName ? {
    "@context": "https://schema.org",
    "@type": "BreadcrumbList",
    itemListElement: [
      { "@type": "ListItem", position: 1, name: "Home", item: SITE_URL },
      { "@type": "ListItem", position: 2, name: productddetails?.subcategory || "Products", item: categoryUrl },
      { "@type": "ListItem", position: 3, name: productName, item: canonicalUrl },
    ],
  } : null;

  const navigate = useNavigate();
  const dispatch = useDispatch(); 

  const DisplayOnlyText = (data) => {
    const parser = new DOMParser();
    var datas = data;
    const htmlString = data;
    return (
      <div dangerouslySetInnerHTML={{ __html: htmlString }} />
    );
  };

  const getProductDetailsRows = () => {
    return [
      { label: "Title", value: productddetails?.name },
      { label: "Seller SKU ID", value: productddetails?.seller_sku_id },
      { label: "HSN Code", value: productddetails?.code },
      { label: "Brand", value: productddetails?.brand },
      { label: "EAN/UPC", value: productddetails?.ean_upc },
      { label: "Country of origin", value: productddetails?.origin },
    ].filter((item) => item?.value !== undefined && item?.value !== null && item?.value !== "");
  };

  const renderProductDetailsTable = () => {
    const productDetailsRows = getProductDetailsRows();
    if(productDetailsRows?.length < 1) {
      return null;
    }
    return (
      <table className="turntable-spec-table">
        <tbody>
          {productDetailsRows?.map((row, rowindex) => {
            return (
              <tr key={rowindex}>
                <th>{row?.label}</th>
                <td>{row?.value}</td>
              </tr>
            );
          })}
        </tbody>
      </table>
    );
  };

  const renderTurntableContents = (showProductDetailsTab = true) => {
    const productDetailsRows = showProductDetailsTab ? getProductDetailsRows() : [];
    if(turntableContents?.length < 1 && productDetailsRows?.length < 1) {
      return null;
    }
    var selectedcontent = turntableContents[selectedTurntableTab] ? turntableContents[selectedTurntableTab] : turntableContents[0];
    var isProductDetailsTab = showProductDetailsTab && selectedTurntableTab == turntableContents?.length;
    return (
      <div className="turntable-product-tabs">
        <div className="turntable-tab-labels">
          {turntableContents?.map((item, index) => {
            return (
              <button
                type="button"
                key={"label-" + index}
                className={selectedTurntableTab == index ? "turntable-tab-label active" : "turntable-tab-label"}
                onClick={() => {
                  setselectedTurntableTab(index);
                }}
              >
                {item?.title}
              </button>
            );
          })}
          {showProductDetailsTab ? (
            <button
              type="button"
              className={isProductDetailsTab ? "turntable-tab-label active" : "turntable-tab-label"}
              onClick={() => {
                setselectedTurntableTab(turntableContents?.length);
              }}
            >
              Product Details
            </button>
          ) : null}
        </div>
        <div className="turntable-tab-panels">
          <div className="turntable-tab-panel active">
            {isProductDetailsTab ? (
              renderProductDetailsTable()
            ) : selectedcontent?.template == "table" ? (
              <table className="turntable-spec-table">
                <tbody>
                  {selectedcontent?.rows?.map((row, rowindex) => {
                    return (
                      <tr key={rowindex}>
                        <th>{row?.label}</th>
                        <td>{row?.value}</td>
                      </tr>
                    );
                  })}
                </tbody>
              </table>
            ) : (
              <ul className="turntable-feature-list">
                {selectedcontent?.points?.map((point, pointindex) => {
                  return <li key={pointindex}>{point}</li>;
                })}
              </ul>
            )}
          </div>
        </div>
      </div>
    );
  };


  const handleproductaddtocart = (data) => {
    console.log('data >>', data);
    var prevcartdata = cartdata;
    var newcartdata = [];
    var cartimage = "";
    if(data?.image1) {
      cartimage = data?.image1;
    } else if(data?.image2) {
      cartimage = data?.image2;
    } else if(data?.image3) {
      cartimage = data?.image3;
    } else if(data?.image4) {
      cartimage = data?.image4;
    } else if(data?.image5) {
      cartimage = data?.image5;
    } else if(data?.image6) {
      cartimage = data?.image6;
    } else if(data?.image7) {
      cartimage = data?.image7;
    } else if(data?.image8) {
      cartimage = data?.image8;
    } else {
      cartimage = "";
    }

    var cartobj = {
      id: data?.id,
      name: data?.name,
      category: data?.category,
      slug: data?.slug,
      subcategory: data?.subcategory,
      cartimage: cartimage,
      price: getRoundedSellingPrice(productddetails?.price, discountpercent),
      quantity: quantity > 0 ? quantity : 1,
      discountpercent: Number(discountpercent) || 0,
      ogprice: roundNumber(productddetails?.price)
    }
    console.log('cartobj >>', cartobj);
    var checkstatus = false;
    for(var i = 0; i < prevcartdata?.length; i++) {
      if(prevcartdata[i].id == data?.id) {
        checkstatus = true;
        var prevobj = prevcartdata[i];
        // prevobj?.quantity =  prevobj?.quantity + 1;
        newcartdata.push(prevobj);
      } else {
        newcartdata.push(prevcartdata[i])
      }
    }
    if(!checkstatus) {
      newcartdata.push(cartobj);
    }
    dispatch({ type: "cartdata", payload: newcartdata });
  }

  const handleproductaddbuynow = (data) => {
    var prevcartdata = cartdata;
    var newcartdata = [];
    var cartimage = "";
    if(data?.image1) {
      cartimage = data?.image1;
    } else if(data?.image2) {
      cartimage = data?.image2;
    } else if(data?.image3) {
      cartimage = data?.image3;
    } else if(data?.image4) {
      cartimage = data?.image4;
    } else if(data?.image5) {
      cartimage = data?.image5;
    } else if(data?.image6) {
      cartimage = data?.image6;
    } else if(data?.image7) {
      cartimage = data?.image7;
    } else if(data?.image8) {
      cartimage = data?.image8;
    } else {
      cartimage = "";
    }

    var cartobj = {
      id: data?.id,
      name: data?.name,
      cartimage: cartimage,
      price: getRoundedSellingPrice(productddetails?.price, discountpercent),
      quantity: quantity > 0 ? quantity : 1,
      discountpercent: Number(discountpercent) || 0,
      ogprice: roundNumber(productddetails?.price)
    }
    // console.log('cartobj >>', cartobj);
    var checkstatus = false;
    for(var i = 0; i < prevcartdata?.length; i++) {
      if(prevcartdata[i].id == data?.id) {
        checkstatus = true;
        var prevobj = prevcartdata[i];
        // prevobj?.quantity =  prevobj?.quantity + 1;
        newcartdata.push(prevobj);
      } else {
        newcartdata.push(prevcartdata[i])
      }
    }
    if(!checkstatus) {
      newcartdata.push(cartobj);
    }
    dispatch({ type: "cartdata", payload: newcartdata });
    let passdata = { coupondiscountamount: 0 };
      // navigate('/checkout', {state: passdata});
      navigate('/cart', {state: passdata});
  }

  const fetchproductdetailsbyslug = async(slug) => {
    setshowloding(true);
        setMissingSlug(null);
    var data = {
      slug: slug,
      device: 'web'
  };
  const headers = {
      headers: {
        "Content-Type": "application/json",
      },
    };

    let resp = await axios
    .post(apiUrl + "getproductdetails",data, headers)
    .then((res) => {
      // console.log('res >>', res.data)
      if(res?.data?.productdata?.length > 0) {
        setproductddetails(res?.data?.productdata[0]);
      } else {
        setproductddetails([]);
        setMissingSlug(slug);
        return;
      }

      if(res?.data?.offers?.length > 0) {
        setofferdata(res?.data?.offers[0]);
      } else {
        setofferdata([]);
      }

      if(res?.data?.relatedproducts?.length > 0) {
        setrelatedproducts(res?.data?.relatedproducts);
      } else {
        setrelatedproducts([]);
      }

      if(res?.data?.turntable_contents?.length > 0) {
        setturntableContents(res?.data?.turntable_contents);
        setselectedTurntableTab(0);
      } else {
        setturntableContents([]);
        setselectedTurntableTab(0);
      }



     //check if percent is there in offers else consider from product details
     var offerdataa = res?.data?.offers[0];
     var prodataa = res?.data?.productdata[0];

     console.log('offerdataa >>', offerdataa);

     var offerdicount = res?.data?.offers?.length > 0 ? res?.data?.offers[0]?.discount_percent : 0;
     var productdiscount = res?.data?.productdata[0]?.discountprice ? res?.data?.productdata[0]?.discountprice : 0;
     var dealsdiscount = res?.data?.productdeals?.length > 0 ? res?.data?.productdeals[0]?.discount_percent : 0;

     let getdiscountpercent = getRoundedDiscountPercent(offerdicount, productdiscount, dealsdiscount);


    //  var getdiscountpercent = 0;
    //  if(offerdataa?.discount_percent > 0) {
    //   getdiscountpercent = offerdataa?.discount_percent;
    //  } else if(prodataa?.discountprice && prodataa?.discountprice > 0) {
    //   getdiscountpercent = prodataa?.discountprice;
    //  } else {
    //   getdiscountpercent = 0;
    //  }

     console.log('getdiscountpercent >>', getdiscountpercent);

     setdiscountpercent(getdiscountpercent);

     })
     .catch((err) => {
      if (err.response?.status === 404) {
        setMissingSlug(slug);
      } else {
        alert(err.message);
      }
    });
    setshowloding(false);
  }

  const handlesubmitnotify = async() => {
    var data = {
      firstname: firstname,
      lastname: lastname,
      email: email,
      number: number,
      product: productddetails?.id
    }

    const headers = {
      headers: {
        "Content-Type": "application/json",
      },
    };
    let resp = await axios
      .post(apiUrl + "createnewnotifymeenquire",data, headers)
      .then((res) => {
        if (res.data.status == "success") {
          Swal.fire({
            title: 'Submitted Successfully!',
            text: "We'll notify you once it's available",
            icon: 'success',
            customClass: {
              icon: 'custom-swal-icon'
            },
            width: '400px',
            confirmButtonText: 'Ok'
          });
          window.location.reload();

        } else {
          Swal.fire({
            title: 'Failed',
            text: "Please try again.",
            icon: 'error',
            customClass: {
              icon: 'custom-swal-icon'
            },
            width: '400px',
            confirmButtonText: 'Ok'
          });
        }
  })
      .catch((err) => {
        alert(err.message);
      });

    console.log('data >>', data)
  }

  useEffect(() => {
    fetchproductdetailsbyslug(slug)
  }, [slug])

  // console.log('productddetails >>', productddetails);
  // console.log('offerdata >>>', offerdata);

  const goToSlide = (index) => {
    console.log('swiperRef.current >>', swiperRef.current.swiper)
    if (swiperRef.current && swiperRef.current.swiper) {
      swiperRef.current.swiper.slideTo(index);
      // setshowmodal(true);
    }
  };

  const goToSlide1 = (index) => {
    setshowmodal(true);
    setTimeout(() => {
      console.log('index >>', index);
    console.log('swiperRefmodal.current >>', swiperRefmodal?.current?.swiper)
    if (swiperRefmodal.current && swiperRefmodal.current.swiper) {
      swiperRefmodal.current.swiper.slideTo(index);
      // setshowmodal(true);
    }
    }, [100])
    
    
  }

  if (missingSlug === slug) return <NotFound />;

  return (
    <>
      <Helmet>
        <title>{productName ? `${productName} | Buy Online at Blisstainment` : "Product | Blisstainment"}</title>
        <meta name="description" content={productDescription} />
        <meta name="robots" content={productName ? "index,follow" : "noindex,follow"} />
        <link rel="canonical" href={canonicalUrl} />
        <meta property="og:type" content="product" />
        <meta property="og:title" content={productName || "Blisstainment Product"} />
        <meta property="og:description" content={productDescription} />
        <meta property="og:url" content={canonicalUrl} />
        {primaryImage ? <meta property="og:image" content={primaryImage} /> : null}
        <meta name="twitter:card" content="summary_large_image" />
        {productSchema ? <script type="application/ld+json">{JSON.stringify(productSchema)}</script> : null}
        {breadcrumbSchema ? <script type="application/ld+json">{JSON.stringify(breadcrumbSchema)}</script> : null}
      </Helmet>
      <Overlay showloader={showloding} />
      {showloding ? (
        <div className="loaderscreenheight"></div>
      ) : (
        <>
          <section className="pd50">
            <div className="container">
              <h1 className="detaipageheadig">
                {productddetails?.formate} {productddetails?.name}
              </h1>
              <div className="row">
                <div className="col-md-5">
                  {/* <img src="https://www.blisstainment.com/assets/products/RR75141%204092001%20-%20COLOURED%20LP%2001.jpg" className='img-responsive' /> */}

                  <Swiper
                    ref={swiperRef}
                    style={{
                      "--swiper-navigation-color": "#fff",
                      "--swiper-pagination-color": "#fff",
                    }}
                    spaceBetween={10}
                    freeMode={true}
                    watchSlidesProgress={true}
                    navigation={true}
                    // thumbs={{ swiper: thumbsSwiper }}
                    modules={[FreeMode, Navigation, Thumbs]}
                    className="mySwiper"
                  >
                    {productMediaItems?.map((item, index) => (
                      <SwiperSlide key={item.file}>
                        {item.type === "video" ? (
                          <div className="product-video-slide">
                            <video controls preload="metadata">
                              <source src={item.url} />
                              Your browser does not support the video tag.
                            </video>
                          </div>
                        ) : (
                          <img
                            src={item.url}
                            style={{ cursor: "pointer" }}
                            onClick={() => {
                              goToSlide1(index);
                            }}
                          />
                        )}
                      </SwiperSlide>
                    ))}
                  </Swiper>
                  <br />

                  {/* tumbnails */}
                  {/* <Swiper
                    //    onSwiper={setThumbsSwiper}
                    spaceBetween={10}
                    slidesPerView={8}
                    freeMode={true}
                    watchSlidesProgress={true}
                    modules={[FreeMode, Navigation, Thumbs]}
                    className="mySwiper2"
                  >
                    {productddetails?.image1 ? (
                      <SwiperSlide>
                        <img
                          src={
                            assetsUrl + "products/" + productddetails?.image1
                          }
                          style={{ cursor: "pointer" }}
                          onClick={() => {
                            goToSlide(0);
                          }}
                        />
                      </SwiperSlide>
                    ) : null}
                    {productddetails?.image2 ? (
                      <SwiperSlide>
                        <img
                          src={
                            assetsUrl + "products/" + productddetails?.image2
                          }
                          style={{ cursor: "pointer" }}
                          onClick={() => {
                            goToSlide(1);
                          }}
                        />
                      </SwiperSlide>
                    ) : null}
                    {productddetails?.image3 ? (
                      <SwiperSlide>
                        <img
                          src={
                            assetsUrl + "products/" + productddetails?.image3
                          }
                          style={{ cursor: "pointer" }}
                          onClick={() => {
                            goToSlide(2);
                          }}
                        />
                      </SwiperSlide>
                    ) : null}
                    {productddetails?.image4 ? (
                      <SwiperSlide>
                        <img
                          src={
                            assetsUrl + "products/" + productddetails?.image4
                          }
                          style={{ cursor: "pointer" }}
                          onClick={() => {
                            goToSlide(3);
                          }}
                        />
                      </SwiperSlide>
                    ) : null}
                    {productddetails?.image5 ? (
                      <SwiperSlide>
                        <img
                          src={
                            assetsUrl + "products/" + productddetails?.image5
                          }
                          style={{ cursor: "pointer" }}
                          onClick={() => {
                            goToSlide(4);
                          }}
                        />
                      </SwiperSlide>
                    ) : null}
                    {productddetails?.image6 ? (
                      <SwiperSlide>
                        <img
                          src={
                            assetsUrl + "products/" + productddetails?.image6
                          }
                          style={{ cursor: "pointer" }}
                          onClick={() => {
                            goToSlide(5);
                          }}
                        />
                      </SwiperSlide>
                    ) : null}
                    {productddetails?.image7 ? (
                      <SwiperSlide>
                        <img
                          src={
                            assetsUrl + "products/" + productddetails?.image7
                          }
                          style={{ cursor: "pointer" }}
                          onClick={() => {
                            goToSlide(6);
                          }}
                        />
                      </SwiperSlide>
                    ) : null}
                    {productddetails?.image8 ? (
                      <SwiperSlide>
                        <img
                          src={
                            assetsUrl + "products/" + productddetails?.image8
                          }
                          style={{ cursor: "pointer" }}
                          onClick={() => {
                            goToSlide(7);
                          }}
                        />
                      </SwiperSlide>
                    ) : null}
                  </Swiper> */}
                  <div className="tumbnail-maindiv">
                    {productMediaItems?.map((item, index) => (
                      <div
                        className="tumbnail-singlediv"
                        key={"thumb-" + item.file}
                        onClick={() => {
                          goToSlide(index);
                        }}
                        style={{ cursor: "pointer" }}
                      >
                        {item.type === "video" ? (
                          <div className="product-video-thumb">
                            <span className="product-video-thumb-play">▶</span>
                          </div>
                        ) : (
                          <img src={item.url} />
                        )}
                      </div>
                    ))}
                  </div>
                </div>

                <div className="col-md-7">
                  <div className="product-content">
                    <h3 className="text-black fontweight500">
                      {productddetails?.artist}
                    </h3>
                    <h3 className="text-black fontweight600">
                      {productddetails?.name}
                    </h3>
                    <h3 className="text-black fontweight500">
                      {productddetails?.formate}
                    </h3>

                    <div>
                      <span className="product-price-details">
                        ₹{getRoundedSellingPrice(productddetails?.price, discountpercent)}
                      </span>{" "}
                      {discountpercent > 0 ? (
                        <span className="clr">
                          <s>₹{roundNumber(productddetails?.price)}</s>
                        </span>
                      ) : null}
                      {discountpercent > 0 ? (
                        <span className="offer">
                          {" "}
                          &nbsp;&nbsp;{discountpercent}% off
                        </span>
                      ) : null}
                    </div>

                    <div className="contentdetails mt-3 mb-3">
                      {/* {DisplayOnlyText(productddetails?.description)} */}
                      

                      {Object.keys(productddetails)?.length > 0 &&
                      productddetails?.stock > 0 ? (
                        productddetails?.id == "1236200000000" ? (
                          <>
                            <label className="labeldetails">Quantity: </label>{" "}
                            <input
                              value={quantity}
                              type="text"
                              defaultValue="1"
                              className="quantitynumber"
                              min="1"
                              max="10"
                            />
                          </>
                        ) : (
                          <>
                            <label className="labeldetails">Quantity: </label>{" "}
                            <input
                              value={quantity}
                              onChange={(t) => {
                                setquantity(t.target.value);
                              }}
                              type="number"
                              defaultValue="1"
                              className="quantitynumber"
                              min="1"
                              max="10"
                            />
                          </>
                        )
                      ) : null}
                    </div>
                    {Object.keys(productddetails)?.length > 0 &&
                    productddetails?.stock > 0 ? (
                      <div className="dflex mt-1 dblock">
                        {Object.keys(productddetails)?.length > 0 ? (
                          <button
                            className="buynow"
                            onClick={() => {
                              handleproductaddbuynow(productddetails);
                            }}
                          >
                            Buy Now
                          </button>
                        ) : null}

                        {cartdata &&
                        Object.keys(cartdata)?.length > 0 &&
                        cartdata?.some(
                          (obj) => obj.id === productddetails?.id
                        ) ? (
                          <button
                            className="buynow"
                            style={{ cursor: "unset" }}
                            disabled
                          >
                            Added
                          </button>
                        ) : (
                          <button
                            className="buynow"
                            onClick={() => {
                              handleproductaddtocart(productddetails);
                            }}
                          >
                            Add to Cart
                          </button>
                        )}
                      </div>
                    ) : (
                      <div className="dflex mt-1">
                        <div className="dflex dblock">
                          <span
                            className="soldoutbtn"
                            style={{
                              backgroundColor: "#e61513",
                              color: "#fff",
                              fontSize: 15,
                            }}
                          >
                            SOLD OUT
                          </span>
                        </div>
                        <div
                          className="dflex dblock"
                          style={{ marginLeft: 10, cursor: "pointer" }}
                          onClick={() => {
                            setshownotifymodal(true);
                          }}
                        >
                          <span
                            className="soldoutbtn btn-primary"
                            style={{
                              backgroundColor: "#e61513",
                              color: "#fff",
                              fontSize: 15,
                            }}
                          >
                            Notify me on available
                          </span>
                        </div>
                      </div>
                    )}

                      {productddetails?.description ? (
                        <div className="mb-3 mt-4 productdescription">
                          {DisplayOnlyText(productddetails?.description)}
                        </div>
                      ) : null}
                      {!isTurntableProduct ? renderTurntableContents(false) : null}
                  </div>
                </div>
              </div>
            </div>
          </section>
          {
            isTurntableProduct ?
            <div className="container mb-5 turntable-full-width-tabs">
              {renderTurntableContents()}
            </div> :
            <hr />
          }
          
          {
            visibleRelatedProducts?.length > 0 ?
            <>
                <div className="container mb-5">
            <h2 className="mb-5 weight600">
              {isTurntableProduct ? "Related Products" : "Customers who bought this item also bought"}
            </h2>
            <Swiper
              slidesPerView={6}
              breakpoints={{
                320: {
                  width: 320,
                  slidesPerView: 2,
                },
              }}
              spaceBetween={20}
              freeMode={true}
              loop={true}
              modules={[FreeMode, Autoplay]}
              className="mySwiper"
            >
              {visibleRelatedProducts?.map((item, index) => {
                var proimage = null;
                if (item?.image1) {
                  proimage = item?.image1;
                } else if (item?.image2) {
                  proimage = item?.image2;
                } else if (item?.image3) {
                  proimage = item?.image3;
                } else if (item?.image4) {
                  proimage = item?.image4;
                } else if (item?.image5) {
                  proimage = item?.image5;
                } else if (item?.image6) {
                  proimage = item?.image6;
                } else if (item?.image7) {
                  proimage = item?.image7;
                } else if (item?.image8) {
                  proimage = item?.image8;
                } else {
                  proimage = null;
                }
                return (
                  <SwiperSlide
                    key={item?.slug ? item?.slug : index}
                    style={{ cursor: "pointer" }}
                  >
                    <Link to={`/entertainment/${item?.slug}`}>
                      <img src={assetsUrl + "products/" + proimage} alt={item?.name || "Related product"} />
                      <div className="img-text">
                        <h6 className="">{item?.name}</h6>
                        <h6>{item?.artist}</h6>
                      </div>
                    </Link>
                  </SwiperSlide>
                );
              })}
            </Swiper>
          </div>
          {
            isTurntableProduct ? null : <hr />
          }
          
            </> : null
            
          }
          

         

          {productddetails?.track_heading_1 ||
          productddetails?.track_heading_2 ||
          productddetails?.track_heading_3 ||
          productddetails?.track_heading_4 ||
          productddetails?.track_heading_5 ||
          productddetails?.track_heading_6 ||
          productddetails?.track_heading_7 ||
          productddetails?.track_heading_8 ? (
            <>
              <div className="container mb-5">
                <h2 className="mb-5 weight600">Track Listing</h2>
                <div className="row">
                  {productddetails?.track_heading_1 &&
                  productddetails?.track_content_1 ? (
                    <div className="col-md-3">
                      <div className="sidea">
                        <h3>{productddetails?.track_heading_1}</h3>
                        <ol>
                          {productddetails?.track_content_1
                            ?.split(",")
                            ?.map((item, index) => {
                              return <li key={index}>{item}</li>;
                            })}
                        </ol>
                      </div>
                    </div>
                  ) : null}
                  {productddetails?.track_heading_2 &&
                  productddetails?.track_content_2 ? (
                    <div className="col-md-3">
                      <div className="sidea">
                        <h3>{productddetails?.track_heading_2}</h3>
                        <ol>
                          {productddetails?.track_content_2
                            ?.split(",")
                            ?.map((item, index) => {
                              return <li key={index}>{item}</li>;
                            })}
                        </ol>
                      </div>
                    </div>
                  ) : null}
                  {productddetails?.track_heading_3 &&
                  productddetails?.track_content_3 ? (
                    <div className="col-md-3">
                      <div className="sidea">
                        <h3>{productddetails?.track_heading_3}</h3>
                        <ol>
                          {productddetails?.track_content_3
                            ?.split(",")
                            ?.map((item, index) => {
                              return <li key={index}>{item}</li>;
                            })}
                        </ol>
                      </div>
                    </div>
                  ) : null}
                  {productddetails?.track_heading_4 &&
                  productddetails?.track_content_4 ? (
                    <div className="col-md-3">
                      <div className="sidea">
                        <h3>{productddetails?.track_heading_4}</h3>
                        <ol>
                          {productddetails?.track_content_4
                            ?.split(",")
                            ?.map((item, index) => {
                              return <li key={index}>{item}</li>;
                            })}
                        </ol>
                      </div>
                    </div>
                  ) : null}
                  {productddetails?.track_heading_5 &&
                  productddetails?.track_content_5 ? (
                    <div className="col-md-3">
                      <div className="sidea">
                        <h3>{productddetails?.track_heading_5}</h3>
                        <ol>
                          {productddetails?.track_content_5
                            ?.split(",")
                            ?.map((item, index) => {
                              return <li key={index}>{item}</li>;
                            })}
                        </ol>
                      </div>
                    </div>
                  ) : null}
                  {productddetails?.track_heading_6 &&
                  productddetails?.track_content_6 ? (
                    <div className="col-md-3">
                      <div className="sidea">
                        <h3>{productddetails?.track_heading_6}</h3>
                        <ol>
                          {productddetails?.track_content_6
                            ?.split(",")
                            ?.map((item, index) => {
                              return <li key={index}>{item}</li>;
                            })}
                        </ol>
                      </div>
                    </div>
                  ) : null}
                  {productddetails?.track_heading_7 &&
                  productddetails?.track_content_7 ? (
                    <div className="col-md-3">
                      <div className="sidea">
                        <h3>{productddetails?.track_heading_7}</h3>
                        <ol>
                          {productddetails?.track_content_7
                            ?.split(",")
                            ?.map((item, index) => {
                              return <li key={index}>{item}</li>;
                            })}
                        </ol>
                      </div>
                    </div>
                  ) : null}
                  {productddetails?.track_heading_8 &&
                  productddetails?.track_content_8 ? (
                    <div className="col-md-3">
                      <div className="sidea">
                        <h3>{productddetails?.track_heading_8}</h3>
                        <ol>
                          {productddetails?.track_content_8
                            ?.split(",")
                            ?.map((item, index) => {
                              return <li key={index}>{item}</li>;
                            })}
                        </ol>
                      </div>
                    </div>
                  ) : null}
                </div>
              </div>
              <hr />
            </>
          ) : productddetails?.tracks ? (
            <>
              <div className="container mb-5">
                <h2 className="mb-5 weight600">Track Listing</h2>
                <div className="sidea tracklisting">
                  {DisplayOnlyText(productddetails?.tracks)}
                </div>
              </div>
              <hr />
            </>
          ) : null}

          {isTurntableProduct ? (
            // <div className="container mb-5 turntable-full-width-tabs">
            //   {renderTurntableContents()}
            // </div>
            null
          ) : (
            <div className="container mb-5">
              <h2 className="mb-3 weight600" style={{ color: "#e6993d" }}>
                Product Details
              </h2>

              <ul className="productdetailslist">
                <li>
                  <span>HSN Code : </span> <span> {productddetails?.code}</span>
                </li>
                <li>
                  <span>Seller SKU ID : </span>{" "}
                  <span> {productddetails?.seller_sku_id}</span>
                </li>
                <li>
                  <span>Publisher : </span>{" "}
                  <span> {productddetails?.publisher}</span>
                </li>
                <li>
                  <span>Edition : </span> <span> {productddetails?.edition}</span>
                </li>
                <li>
                  <span>Composer : </span>{" "}
                  <span> {productddetails?.composer}</span>
                </li>
                <li>
                  <span>EAN : </span> <span> {productddetails?.ean_upc}</span>
                </li>
                <li>
                  <span>Artist : </span> <span> {productddetails?.artist}</span>
                </li>
                <li>
                  <span>Country of origin : </span>{" "}
                  <span> {productddetails?.origin}</span>
                </li>
                <li>
                  <span>Record Label/Studio : </span>{" "}
                  <span> {productddetails?.record_label_studio}</span>
                </li>
                <li>
                  <span>Format : </span> <span> {productddetails?.formate}</span>
                </li>
                <li>
                  <span>Number of disc : </span>{" "}
                  <span> {productddetails?.no_of_disc}</span>
                </li>
                <li>
                  <span>Language : </span>{" "}
                  <span> {productddetails?.language}</span>{" "}
                </li>
              </ul>
            </div>
          )}

          {/*Add modal */}
          <Modal
            show={showmodal}
            onHide={() => setshowmodal(false)}
            size="lg"
            className="custom-width-modal"
          >
            <Modal.Header closeButton>
              <Modal.Title style={{ fontSize: 19 }}></Modal.Title>
            </Modal.Header>
            <Modal.Body>
              <div className="product-details-swipper-modal">
                <Swiper
                  ref={swiperRefmodal}
                  style={{
                    "--swiper-navigation-color": "#fff",
                    "--swiper-pagination-color": "#fff",
                  }}
                  spaceBetween={10}
                  navigation={true}
                  // thumbs={{ swiper: thumbsSwiper }}
                  modules={[FreeMode, Navigation, Thumbs]}
                  className="mySwiper"
                >
                  {productMediaItems?.map((item) => (
                    <SwiperSlide key={"modal-" + item.file}>
                      {item.type === "video" ? (
                        <div className="product-video-slide product-video-slide-modal">
                          <video controls preload="metadata">
                            <source src={item.url} />
                            Your browser does not support the video tag.
                          </video>
                        </div>
                      ) : (
                        <img src={item.url} />
                      )}
                    </SwiperSlide>
                  ))}
                </Swiper>
              </div>
            </Modal.Body>
          </Modal>

          {/* Notification modal */}
          <Modal
            show={shownotifymodal}
            onHide={() => setshownotifymodal(false)}
            size="md"
            className="custom-width-modal"
          >
            <Modal.Header closeButton>
              <Modal.Title style={{ fontSize: 17 }}>Fill Details</Modal.Title>
            </Modal.Header>
            <Modal.Body>
              <div className="notifymodalform over-all-address">
                <div className="row">
                  <div className="col-md-6 mb-3">
                    <label for="name">First Name</label>
                    <input
                      value={firstname}
                      onChange={(t) => {
                        setfirstname(t.target.value);
                      }}
                      type="text"
                      className="form-control"
                    />
                  </div>
                  <div className="col-md-6 mb-3">
                    <label for="mobile">Last Name</label>
                    <input
                      value={lastname}
                      onChange={(t) => {
                        setlastname(t.target.value);
                      }}
                      type="text"
                      className="form-control"
                    />
                  </div>
                  <div className="col-md-12 mb-3">
                    <label for="name">Email</label>
                    <input
                      value={email}
                      onChange={(t) => {
                        setemail(t.target.value);
                      }}
                      type="email"
                      className="form-control"
                    />
                  </div>
                  <div className="col-md-12 mb-3">
                    <label for="name">Number</label>
                    <input
                      value={number}
                      onChange={(t) => {
                        setnumber(t.target.value);
                      }}
                      type="number"
                      className="form-control"
                    />
                  </div>
                  <div className="col-md-12">
                    <button
                      className="btn btn-primary btn-lg btn-block"
                      id="checkoutButton"
                      type="submit"
                      style={{ width: "100%", height: 42 }}
                      onClick={() => {
                        handlesubmitnotify();
                      }}
                      // onClick={() => {
                      //   handlecheckout();
                      // }}
                    >
                      Submit
                    </button>
                  </div>
                </div>
              </div>
            </Modal.Body>
          </Modal>
        </>
      )}
    </>
  );
};

export default ProductDetails;
